import { DatePicker, TimePicker, TimePickerProps } from 'antd';
import React, { useEffect, useState } from 'react'
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs, { Dayjs } from "dayjs";
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../core/common/textFields/TextField';
import { useGetSaleInfoByIdQuery, useUpsertSaleInfoDetailsMutation } from '../../../../services/EndPointsApis';
import { useFormik } from 'formik';
import { initialValuesSale } from '../../Projects/SaleWizardData/InitialValuesSalesWizard';
import Ribbon from '../../../../core/common/ribbon/ribbon';
import { toast } from 'react-toastify';
import * as Yup from "yup";
import { usePermission } from '../../../../core/hooks/PermissionHook';
import { constantsPermission } from '../../../../Config/Constants';
import FormattedNumber from '../../../../core/common/textFields/FormatNumber';


const SalesInfoTab = ({ getallActiveUsers, refetchClientView, setSaleInfoData, projectId, projectLookups, setTotalAmount }: any) => {
    //PermissionHook
    const { view: viewSaleInfo, edit: editSaleInfo, create: createSaleInfo } = usePermission(constantsPermission?.moduleId?.saleInfo);


    const [paymentType, setPaymentType] = useState({ id: 0, value: "" });
    const [paymentAmt, setPaymentAmt] = useState("");
    const [showModal, setShowModal] = useState(false);

    const [totalContractAmount, setTotalContractAmount] = useState(0)
    const customStyles: StylesConfig = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? "rgba(177, 31, 40, 1)" : "#fff",
            color: state.isFocused ? "#fff" : "#000",
            "&:hover": {
                backgroundColor: "rgba(177, 31, 40, 1)",
            },
        }),
    };
    dayjs.extend(customParseFormat);

    //Get Sale Info
    const { data: saleInfoData, refetch } = useGetSaleInfoByIdQuery({ ProjectId: projectId })
    //   upsert Sale Info
    const [UpsertSaleInfo, { data: UpsertData, isSuccess, isError, error }] = useUpsertSaleInfoDetailsMutation()
    const formatNumber = (value: any) =>
        value ? Number(value).toFixed(2) : "0";

    const [remainingAmount, setRemainingAmount] = useState("0");
    const [remainingAmountFormatted, setRemainingAmountFormatted] = useState(0);


    const saleInfoSchema = Yup.object().shape({
        lst_SaleRepresentative: Yup.object().shape({
            id: Yup.string().required('Sale Representative ID is required'),
            value: Yup.string().required('Sale Representative value is required'),
        }),
        saleDate: Yup.string().required("Sale Date is required"),
        salePrice: Yup.string().required("Sale Price is required"),

    });



    const formik = useFormik({
        validationSchema: saleInfoSchema,
        initialValues: initialValuesSale,

        onSubmit: (values) => {
            // UpsertSaleInfo({ ...values, projectId: projectId, childId: projectId});
            const updatedSchedule = values.projectPaymentSchedule.map((item) => ({
                ...item,
                changeBy: item.changeBy === "" ? 0 : item.changeBy,
            }));

            UpsertSaleInfo({
                ...values,
                projectId: projectId,
                childId: projectId,
                projectPaymentSchedule: updatedSchedule,
            });
        }
    });

    const { resetForm } = formik;
    //GetSaleInfoById

    // useEffect(() => {
    //     if (!formik.values.projectPaymentSchedule?.length && saleInfoData?.result?.projectPaymentSchedule) {
    //         formik.setValues({
    //             ...formik.values,
    //             projectPaymentSchedule: saleInfoData.result.projectPaymentSchedule.map((item: any) => ({
    //                 ...item,
    //                 newAmount: item.newAmount || 0,
    //             })),
    //         });
    //     }
    // }, [saleInfoData]);

    useEffect(() => {
        if (isSuccess) {
            toast.success(UpsertData?.message);
            refetchClientView()
            // resetForm();
            refetch()
        }

    }, [isSuccess]);

    useEffect(() => {
        refetch()
    }, []);

    useEffect(() => {
        if (saleInfoData?.result && Object.keys(saleInfoData?.result).length > 0) {
            formik.setValues({ ...saleInfoData?.result });
        } else {
            // setUpdateId(0);
        }
    }, [saleInfoData]);


    const handleDateChange = (date: Dayjs | null) => {
        // setSelectedFreshAptDate(date);
        formik.setFieldValue('saleDate', date ? date.format('YYYY-MM-DD') : null);
    };


    useEffect(() => {
        const total = formik?.values?.projectPaymentSchedule?.reduce(
            (sum: any, item: any) => sum + (item?.newAmount || 0),
            0
        ) || 0;
        // const totalAmount = formatNumber(total)
        formik.setFieldValue("totalPaymentAmt", total);
        const remaining = formik?.values?.totalContractAmt - total;
        const remainingFormatted = new Intl.NumberFormat("en-US").format(remaining);
        setRemainingAmount(remainingFormatted);
        setRemainingAmountFormatted(remaining)
        formik.setFieldValue("remainingAmount", remainingAmount);
    }, [formik.values, setRemainingAmount]);

    const handleTableChange = () => {
        // Check if payment type and amount are valid
        if (!paymentType.id && paymentAmt !== '0' || !paymentAmt) {
            toast.error('Please add both payment type and amount.');
            return;
        }
        const maxOrderId = formik.values.projectPaymentSchedule.reduce(
            (max: number, entry: any) => Math.max(max, entry.orderId || 0),
            0
        );

        const newOrderId = maxOrderId + 1;

        // Create a new entry
        const newEntry = {
            id: crypto.randomUUID(),
            projectId: projectId,
            childId: projectId,
            orderId: newOrderId,
            lst_PaymentType: paymentType,
            paymentAmt: parseFloat(paymentAmt),
            newAmount: parseFloat(paymentAmt),
            changeBy: null,
            lst_CreatedBy: { id: 0, value: "" },
            lst_Modified: { id: 0, value: "" },
            createdDT: new Date().toISOString(),
            modifiedDT: new Date().toISOString(),
        };


        const filteredSchedule = formik.values.projectPaymentSchedule.filter(
            (entry) => entry.id !== "3fa85f64-5717-4562-b3fc-2c963f66afa6"
        );
        // const updatedSchedule = [...filteredSchedule, newEntry].map(
        //     (entry, index) => ({
        //         ...entry,
        //         orderId: index + 1,
        //     })
        // );
        const updatedSchedule = [...filteredSchedule, newEntry]
        formik.setFieldValue("projectPaymentSchedule", updatedSchedule);

        setPaymentType({ id: 0, value: "" });
        setPaymentAmt("");
    };

    const handleReset = () => {
        formik.setValues({
            ...formik.values,
            projectPaymentSchedule: [],
        });
    }

    useEffect(() => {
        formik.setFieldValue(
            "totalContractAmt",
            (Number(formik?.values?.salePrice) || 0) + (Number(formik?.values?.totalAdendum) || 0)
        );
    }, [formik.values]);

    const handleSalePriceChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value.replace(/,/g, "");
        if (/^\d*$/.test(inputValue)) {
            formik.setFieldValue("salePrice", Number(inputValue));
        }
    };



    const formatComma = (num: number | string) => {
        if (num === null || num === undefined) return "0.0";
        const numericValue = String(num).replace(/,/g, "");
        if (isNaN(Number(numericValue))) return String(num);
        return Number(numericValue).toLocaleString();
    };

    const disbaleAddPayment = saleInfoData?.result?.projectPaymentSchedule.length > 0
    return (
        <>
            {/* {editSaleInfo &&
                <Ribbon
                    buttonText='Save'
                    buttonClass="add-popup ribbon-btn "
                    onClickbtn={formik.handleSubmit}
                    disabled={parseFloat(remainingAmount.replace(/,/g, '')) !== 0}
                />
            } */}
            <div className='row mt-2'>
                <div className='col-md-8'>
                    <div className='row'>
                        <div className="col-md-4">
                            <label className="input-label">
                                Start Date <span className="text-danger">*</span>
                            </label>
                            <div className="form-wrap mb-0 icon-form">
                                <span className="form-icon">
                                    <i className="ti ti-calendar-check" />
                                </span>
                                <DatePicker
                                    className="form-control datetimepicker deals-details"
                                    onChange={handleDateChange}
                                    disabled={saleInfoData?.result?.saleDate !== null}
                                    value={formik.values?.saleDate ? dayjs(formik.values.saleDate, 'YYYY-MM-DD') : null}
                                    format="MMM-DD-YYYY"

                                />
                            </div>
                            {formik.touched.saleDate && formik.errors.saleDate && (
                                <>
                                    <div className="error">{formik.errors.saleDate}</div>
                                </>
                            )}
                        </div>

                        <div className="col-md-4">
                            <label className="input-label">
                                Sales Representative <span className="text-danger"> *</span>
                            </label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={getallActiveUsers?.result?.
                                    map((option: any) => ({
                                        label: option?.userName,
                                        value: option?.userId
                                    }))}
                                value={
                                    formik.values?.lst_SaleRepresentative?.id
                                        ? {
                                            value: formik.values?.lst_SaleRepresentative?.id,
                                            label: formik.values?.lst_SaleRepresentative?.value || '',
                                        }
                                        : null
                                }
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_SaleRepresentative.id', selectedOption.value);
                                    formik.setFieldValue('lst_SaleRepresentative.value', selectedOption.label);
                                }}
                                isDisabled={saleInfoData?.result?.lst_SaleRepresentative?.id !== null}
                            />
                            {formik.touched.lst_SaleRepresentative && formik.errors.lst_SaleRepresentative && (
                                <>
                                    <div className="error">{formik.errors.lst_SaleRepresentative.id}</div>
                                </>
                            )}
                        </div>

                        <div className="col-md-4">
                            <label className="input-label">
                                Follow Up Sales Representative
                            </label>
                            <Select
                                styles={customStyles}
                                className="select"
                                options={getallActiveUsers?.result?.
                                    map((option: any) => ({
                                        label: option?.userName,
                                        value: option?.userId
                                    }))}
                                value={
                                    formik.values?.lst_FollowUpSale?.id
                                        ? {
                                            value: formik.values?.lst_FollowUpSale?.id,
                                            label: formik.values?.lst_FollowUpSale?.value || '',
                                        }
                                        : null
                                }
                                onChange={(selectedOption: any) => {
                                    formik.setFieldValue('lst_FollowUpSale.id', selectedOption.value);
                                    formik.setFieldValue('lst_FollowUpSale.value', selectedOption.label);
                                }}
                                isDisabled
                            // isDisabled={saleInfoData?.result?.lst_FollowUpSale?.id !== null}f

                            />
                        </div>
                    </div>
                    {/* table  */}
                    <div className='card mt-2'>
                        <div className='card-body card-css'>
                            <div className="table-responsive mt-2 overflow-auto saleInfoTableHeight">
                                <table className="table datanew dataTable no-footer table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                Order
                                            </th>
                                            <th>
                                                Payment Type
                                            </th>
                                            <th>
                                                Payment Amt
                                            </th>
                                            <th>
                                                Change By
                                            </th>
                                            <th>
                                                New Amount
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {formik?.values?.projectPaymentSchedule?.map((item: any, index: any) => (
                                            <tr key={item.id}>
                                                <td>{index + 1}</td>
                                                <td>{item.lst_PaymentType?.value}</td>
                                                <td className='text-center'>
                                                    {/* {formatComma(item.paymentAmt ?? '0.0$')} */}
                                                    <FormattedNumber value={item?.paymentAmt} />
                                                </td>
                                                <td className='text-end'>
                                                    <input
                                                        type="text"
                                                        className="form-control text-end"
                                                        value={formik.values?.projectPaymentSchedule?.[index]?.changeBy === 0 ? "" : formik.values?.projectPaymentSchedule?.[index]?.changeBy ?? ""}
                                                        onChange={(e) => {
                                                            const rawValue = e.target.value.replace(/,/g, "");

                                                            if (/^-?\d*\.?\d*$/.test(rawValue) || rawValue === "-" || rawValue === "") {
                                                                // Always update with raw input
                                                                formik.setFieldValue(`projectPaymentSchedule[${index}].changeBy`, rawValue);

                                                                if (!isNaN(Number(rawValue)) && rawValue !== "-" && rawValue !== "") {
                                                                    const numericValue = Number(rawValue);

                                                                    formik.setFieldValue(`projectPaymentSchedule[${index}].orderId`, item.orderId);
                                                                    formik.setFieldValue(`projectPaymentSchedule[${index}].lst_PaymentType.id`, item.lst_PaymentType?.id);
                                                                    formik.setFieldValue(
                                                                        `projectPaymentSchedule[${index}].newAmount`,
                                                                        numericValue + (formik.values?.projectPaymentSchedule?.[index]?.paymentAmt || 0)
                                                                    );
                                                                } else {
                                                                    // Optional: Reset newAmount if raw value is empty or invalid
                                                                    formik.setFieldValue(
                                                                        `projectPaymentSchedule[${index}].newAmount`,
                                                                        formik.values?.projectPaymentSchedule?.[index]?.paymentAmt || 0
                                                                    );
                                                                }
                                                            }
                                                        }}
                                                        onBlur={(e) => {
                                                            const rawVal = e.target.value.replace(/,/g, "");
                                                            const finalValue = rawVal && !isNaN(Number(rawVal)) ? Number(rawVal) : "";
                                                            formik.setFieldValue(`projectPaymentSchedule[${index}].changeBy`, finalValue);
                                                        }}
                                                        disabled
                                                    />
                                                </td>

                                                {/* <td className='text-center'>{formatComma(formik.values.projectPaymentSchedule[index]?.newAmount)}</td> */}
                                                <td className='text-center'> <FormattedNumber value={formik.values.projectPaymentSchedule[index]?.newAmount} /></td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            {/* new table  */}
                            <div></div>
                            {/* <h5 className='mt-4 mb-2'>Add New Payment</h5> */}
                            {/* <div className='d-flex align-items-end '>
                                <div className="col-md-5 mb-3">
                                    <label className="input-label">
                                        Select a Type
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select custom-saleinfo-select"
                                        options={projectLookups?.result?.Lst_PaymentSchedule?.map((option: any) => ({
                                            label: option?.value,
                                            value: option?.id,
                                        }))}
                                        value={
                                            paymentType.id
                                                ? { label: paymentType.value, value: paymentType.id }
                                                : null
                                        }
                                        onChange={(selectedOption: any) => {
                                            setPaymentType({ id: selectedOption.value, value: selectedOption.label });
                                        }}
                                    />
                                </div>
                                <div className="col-md-5 mt-4 mb-3">
                                    <div className='d-flex gap-3 align-items-end'>
                                        <p className='mb-0 ms-2'>

                                        </p>
                                        <div className="form-wrap w-100 mb-0 d-flex align-items-center ">
                                            <p className='mb-0'>$</p>
                                            <div className='w-100 '>
                                                <TextField
                                                    type="text"
                                                    fieldClass='text-end'
                                                    value={paymentAmt}

                                                    onChange={(e) => {
                                                        const val = e.target.value;
                                                        if (/^-?\d*\.?\d*$/.test(val) || val === '' || val === '-') {
                                                            setPaymentAmt(val);
                                                        }
                                                    }}
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className='col-md-2 mt-4 mb-3'>
                                    <div className='d-flex justify-content-center gap-2'>
                                        <button className='btn btn-primary px-3 py-2' onClick={handleTableChange}
                                            disabled={parseFloat(remainingAmount.replace(/,/g, '')) === 0 || disbaleAddPayment}
                                        >
                                            Add
                                        </button>
                                        <button className='btn btn-light px-3 py-2' onClick={handleReset}>
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
                <div className='col-md-4'>
                    <div className='card'>
                        <div className='card-body card-css'>
                            <h5 className='mb-2 mt-2'>Payment Schedule</h5>
                            <div className="col-md-12 mb-2">
                                <div className='d-flex justify-content-between'>
                                    <div className='input-label '>
                                        Sale Price
                                    </div>
                                    <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                                        <FormattedNumber value={formik.values?.salePrice} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12 mb-2">
                                  <div className='d-flex justify-content-between'>
                                    <div className='input-label '>
                                       Total Addenda Amount
                                    </div>
                                    <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                                        <FormattedNumber value={formik.values?.totalAdendum} />
                                    </div>
                                </div>

                            </div>
                            <div className="col-md-12 mb-2">
                                  <div className='d-flex justify-content-between'>
                                    <div className='input-label '>
                                      Total Contract Amount
                                    </div>
                                    <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                                        <FormattedNumber value={formik.values?.totalContractAmt} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                 <div className='d-flex justify-content-between'>
                                    <div className='input-label '>
                                     Total Payment Distribution
                                    </div>
                                    <div className='br-gray w-50 text-end py-2 px-3 bg-gray'>
                                        <FormattedNumber value={formik.values?.totalPaymentAmt} />
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-12'></div>
                            <div className="col-md-12 mt-2 w-100 d-flex justify-content-end text-end ">
                                <div className='br-gray py-2 px-3 w-50'>
                                    <p className='color-red fs-15 fw-600'> {<FormattedNumber value={remainingAmountFormatted} />}</p>
                                </div>

                            </div>
                            {parseFloat(remainingAmount.replace(/,/g, '')) < 0 && (
                                <p className="color-red fw-semibold d-flex justify-content-end">
                                    Negative amount not considered
                                </p>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </>

    )
}

export default SalesInfoTab